import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import { BackofficeConversationExperimentDomainsResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<
  z.infer<typeof BackofficeConversationExperimentDomainsResponseDataSchema>
>

export const getBackofficeConversationExperimentDomainsQuery = () => {
  return queryOptions({
    queryKey: ["backofficeConversationExperimentDomains"],
    staleTime: 15 * MINUTES_TO_MILLIS,
    retry: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/experiments/domains", { signal })
      return data.data
    },
  })
}
